// src/components/TargetAudience.js
import React from 'react';
import { IoBusinessOutline, IoColorPaletteOutline, IoCodeSlashOutline, IoMegaphoneOutline } from 'react-icons/io5';

const audiences = [
  {
    icon: IoMegaphoneOutline,
    title: "Marketing Teams",
    description: "Coordinate campaigns, manage approvals, and track cross-platform analytics from a single source of truth."
  },
  {
    icon: IoBusinessOutline,
    title: "Startup Founders",
    description: "Build a powerful brand presence without hiring a large team. Automate your content and focus on building your product."
  },
  {
    icon: IoColorPaletteOutline,
    title: "Content Creators",
    description: "Overcome creative block with endless AI-powered ideas and streamline your publishing schedule across all channels."
  },
  {
    icon: IoCodeSlashOutline,
    title: "Digital Agencies",
    description: "Effortlessly manage multiple client accounts, generate beautiful reports, and deliver exceptional results at scale."
  },
];

const TargetAudience = ({ title = "Built for the Future of Social Media Teams" }) => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            {title}
          </h2>
        </div>
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-8 sm:mt-20 lg:max-w-none md:grid-cols-2">
          {audiences.map((audience) => (
            <div 
              key={audience.title}
              className="flex items-start gap-x-6 p-8 bg-dark-card/40 backdrop-blur-lg rounded-2xl border border-white/10"
            >
              <div className="flex h-14 w-14 flex-none items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end">
                <audience.icon className="h-8 w-8 text-white" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-dark-text-primary">{audience.title}</h3>
                <p className="mt-2 text-sm text-dark-text-secondary">{audience.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;